/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import _defaultTo from "lodash/defaultTo";
import dayjs from "dayjs";

export const convertToLocaleString = (value: dayjs.ConfigType) => {
  if (_defaultTo(value, "") === "") {
    return "";
  }

  const isoDayjs = dayjs(value, undefined, true);
  if (isoDayjs.isValid()) {
    return isoDayjs.format("DD.MM.YYYY");
  }

  const localeDayjs = dayjs(value, ["DD.MM.YYYY", "DD.M.YYYY", "D.MM.YYYY", "D.M.YYYY"], true);
  if (localeDayjs.isValid()) {
    return localeDayjs.format("DD.MM.YYYY");
  }

  return "";
};
